import { polyfill } from 'es6-promise';

/*
 * A class providing various IE11-specific polyfills to provide additional
 * functionality. Polyfills added:
 * 
 *   - Array.forEach
 *   - Array.flatMap
 *   - Array.find
 *   - NodeList.forEach
 *   - Promise
 *   - String.startsWith
 */
export function init() {
    polyfill();

    if (!Array.prototype.forEach)
        Array.prototype.forEach = forEach;
    if (!NodeList.prototype.forEach)
        NodeList.prototype.forEach = forEach;

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = (value: string) => this[0] === value;
    }

    function forEach(callback, thisArg) {
        if (typeof callback !== 'function')
            throw new TypeError(callback + ' is not a function');

        const array = this;
        thisArg = thisArg || this;
        for (let i = 0, l = array.length; i !== l; ++i)
            callback.call(thisArg, array[i], i, array);
    }

    // https://estada.ch/2019/6/10/javascript-arrayprototypeflatmap-polyfill/
    if (!Array.prototype.flatMap) {
        Object.defineProperty(Array.prototype, 'flatMap', {
            value: function(callback, thisArg) {
                var self = thisArg || this;
                if (self === null)
                    throw new TypeError('Array.prototype.flatMap called on null or undefined');
                if (typeof callback !== 'function')
                    throw new TypeError(callback + ' is not a function');
    
                let list = [],
                    o = Object(self),
                    len = o.length >>> 0;
    
                for (var k = 0; k < len; ++k) {
                    if (k in o) {
                        var part_list = callback.call(self, o[k], k, o);
                        list = list.concat(part_list);
                    }
                }
    
                return list;
            }
        });
    }

    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find#Polyfill
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
          value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
              throw TypeError('"this" is null or not defined');
            }
      
            var o = Object(this);
      
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
      
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
              throw TypeError('predicate must be a function');
            }
      
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
      
            // 5. Let k be 0.
            var k = 0;
      
            // 6. Repeat, while k < len
            while (k < len) {
              // a. Let Pk be ! ToString(k).
              // b. Let kValue be ? Get(O, Pk).
              // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
              // d. If testResult is true, return kValue.
              var kValue = o[k];
              if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
              }
              // e. Increase k by 1.
              k++;
            }
      
            // 7. Return undefined.
            return undefined;
          },
          configurable: true,
          writable: true
        });
      }
}